export default __webpack_public_path__ + "static/media/sea2.64bed040.jpg";